module.exports = __webpack_public_path__ + "img/bg-proyectos-1.043ed4aa.png";